import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18n from './translate/i18n';
import MainForm from './pages/MainForm/MainForm'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <MainForm />
    </I18nextProvider>
  </React.StrictMode >
);
